<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="statistic-wrapper">
    <span v-if="props.isFetched">
      {{ statistic }}
    </span>
    <span v-if="props.isFetched && statistic > 1">
      {{ $tc(props.i18nLabel, { number: statistic }) }}
    </span>
    <span v-else-if="props.isFetched && statistic >= 0">
      {{ $tc(props.i18nLabel) }}
    </span>
    <span v-if="props.isError">
      {{
        `${$tc(props.i18nLabel)}
        ${$t('common.status.na')} (${$t('common.status.unavailable_data')})`
      }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import './styles/statistic.scss';

const props = defineProps({
  value: {
    type: Number,
    default: 0
  },
  isFetched: {
    type: Boolean
  },
  isError: {
    type: Boolean
  },
  i18nLabel: {
    type: String,
    default: ''
  }
});

const statistic = ref(0);

watch(
  () => props.value,
  () => {
    statistic.value = props.value;
  },
  { immediate: true }
);
</script>
